import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICoreService, ICoreServices } from "./coreservicesModal";
import { ActiveInactiveCoreServices, CoreServicesDetailsImageUpload, createCoreServices, deleteCoreServices, getAllActiveCoreServices, getAllCoreServices, getCoreServicesByID, updateCoreServices } from "./services/coreservices.services";

const initialState: ICoreServices = {
  loading: false,
  formLoading: false,
  error: "",
  CoreServiceID: null,
  CoreServiceList: [],
  CoreServiceDetail: {
    ID: null,
    Title: "",
    Description: "",
    Image: null,
    URL: "",
    IsActive: 1,
  },
};

const coreServiceSlice = createSlice({
  name: "coreservices",
  initialState,
    reducers: {
      clearCoreServiceDetails: (state) => {
        state.CoreServiceDetail = initialState.CoreServiceDetail;
      },
      setCoreServiceID: (state, action) => {
        state.CoreServiceID = action.payload;
      },
      clearCoreServiceID: (state) => {
        state.CoreServiceID = initialState.CoreServiceID;
      },
    },
    extraReducers: (builder) => {
      builder.addCase(getAllCoreServices.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(
        getAllCoreServices.fulfilled,
        (state, action: PayloadAction<ICoreService[]>) => {
          state.loading = false;
          state.CoreServiceList = action.payload || [];
        }
      );
      builder.addCase(getAllCoreServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.CoreServiceList = [];
      });
      builder.addCase(createCoreServices.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(createCoreServices.fulfilled, (state) => {
        state.loading = false;
      });
      builder.addCase(createCoreServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
      builder.addCase(updateCoreServices.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(updateCoreServices.fulfilled, (state) => {
        state.loading = false;
      });
      builder.addCase(updateCoreServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
      builder.addCase(deleteCoreServices.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(deleteCoreServices.fulfilled, (state) => {
        state.loading = false;
      });
      builder.addCase(deleteCoreServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
      builder.addCase(getCoreServicesByID.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(getCoreServicesByID.fulfilled, (state, action: any) => {
        state.loading = false;
        state.CoreServiceDetail = action.payload;
      });
      builder.addCase(getCoreServicesByID.rejected, (state, action) => {
        state.loading = false;
        state.CoreServiceDetail = initialState.CoreServiceDetail;
        state.error = action.error.message || "Something went wrong";
      });
      builder.addCase(getAllActiveCoreServices.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(
        getAllActiveCoreServices.fulfilled,
        (state, action: PayloadAction<ICoreService[]>) => {
          state.loading = false;
          state.CoreServiceList = action.payload || [];
        }
      );
      builder.addCase(getAllActiveCoreServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.CoreServiceList = [];
      });
      builder.addCase(ActiveInactiveCoreServices.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(ActiveInactiveCoreServices.fulfilled, (state) => {
        state.loading = false;
      });
      builder.addCase(ActiveInactiveCoreServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  
      // IMAGE UPLOAD
      builder.addCase(CoreServicesDetailsImageUpload.pending, (state) => {
        state.loading = true;
        state.error = "";
      });
      builder.addCase(CoreServicesDetailsImageUpload.fulfilled, (state) => {
        state.loading = false;
      });
      builder.addCase(CoreServicesDetailsImageUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
    },
  });
  
  export const { clearCoreServiceDetails, clearCoreServiceID, setCoreServiceID } =
    coreServiceSlice.actions;
  export default coreServiceSlice.reducer;
  